import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, GuardResult, MaybeAsync } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { LoginService } from '../shared/services/login/login.service';
import { map } from 'rxjs';
import { APP_CONST } from '../shared/constants/app-constants';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import * as _ from 'lodash';
@Injectable({ providedIn: 'root' })

export class AuthGuard implements CanActivate {

  constructor(private loginService: LoginService, private router: Router, private __helpers: HelpersService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkUserAccess(route);
  }

  checkUserAccess(route: ActivatedRouteSnapshot) {
    // Check if the manager data is last synced 30sec old or not, if older, Get data from API
    // To minimized the time for routing.
    const getLastManagerDetailsSynced = _.get(this.__helpers.helpers['managerDetails'], 'last_synced_details', null);
    if (getLastManagerDetailsSynced && getLastManagerDetailsSynced != null) {
      const differenceInSeconds = (new Date().getTime() - getLastManagerDetailsSynced) / 1000;
      this.setDetails(route);
      if (differenceInSeconds > 59) {
        return this.updateManagerDetails(route);
      } else {
        return true;
      }
    } else {
      return this.updateManagerDetails(route);
    }
  }

  updateManagerDetails(route) {
     (document.body.style as any).setProperty('cursor', 'progress', 'important');
      // document.title = 'Loading... ⏳'; 
    return this.loginService.checkUserIsLoggedIn().pipe(map(response => {
       // document.title = ''; 
       (document.body.style as any).setProperty('cursor', 'default', 'important');
      // console.log("Logged in", response)
      if (response && response['data'] && response['data']['code'] && response['data']['code'] == 1) {
        this.__helpers.resetAppState('full_reset');
        this.router.navigate([APP_CONST.ROUTE_LOGIN]);
        return false;
      } else {
if (response &&response.data && response.data['isManagerLoggedIn'] && response['data']['manager'] && (response['data']['manager']['is_lw3_permitted_user'] || (response['data']['manager']['allowed_dashboard_versions']  && response['data']['manager']['allowed_dashboard_versions'].includes('v3')))) {
        //  if (response && response.data && response.data['isManagerLoggedIn'] && response['data']['manager'] && response['data']['manager']['allowed_dashboard_versions'] &&  response['data']['manager']['allowed_dashboard_versions'].includes('v3')) {
          if (response && response.data && response.data['isManagerLoggedIn']) {
            response.data['last_synced_details'] = new Date().getTime();
            this.__helpers.helpers['managerDetails'] = response.data;
            this.setDetails(route);
            return true;
          } else {
            this.__helpers.resetAppState('full_reset');
            this.router.navigate([APP_CONST.ROUTE_LOGIN])
            return false;
          }
        } else {
          this.__helpers.resetAppState('full_reset');
          // this.router.navigate(["NotAuthorizedForLW3.0"])
          this.router.navigate(["message"], { queryParams: { status: '402' } });
          return false;
        }
      }
    }));
  }

  setDetails(route) {
    if (route.queryParams) {
      if (route.queryParams['project_id']) {
        this.__helpers.helpers['isAccount'] = false;
      } else if (route.queryParams['account_id']) {
        this.__helpers.helpers['isAccount'] = true;
      } else {
        delete this.__helpers.helpers['isAccount'];
      }
    } else {
      delete this.__helpers.helpers['isAccount'];
    }
    window['Helpers'] = this.__helpers.consoleData();
  }
  
}
